/**
 * 交易行情映射配置使用
 * 文件使用位置：trading.vue、tradetail.vue、gpdetail.vue、buy/index.vue
 * **/
export const moldcity = {
  "1-1": "全国-挂牌",
  "1-11": "全国-大宗",
  "1-2": "北京",
  "1-3": "上海",
  "1-4": "广州",
  "1-5": "湖北",
  "1-6": "福建",
  "1-7": "天津",
  "1-8": "深圳",
  "1-9": "重庆",
  "1-10": "四川",
  "2-1": "全国",
  "2-6": "福建",
};

export const moldtxt = {
  1: "配额",
  2: "CCER",
  3: "PCER",
  4: "FCER",
  5: "配额(有偿竞价)",
  6: "国内绿证",
  7: "绿电",
};

export const moldtype = {
  1: "ea",
  2: "ccer",
  3: "pcer",
  4: "fcer",
  5: "eay",
  6: "lvzheng",
};

export const modlname = {
  ea1: "配额-全国挂牌",
  ea2: "配额-北京",
  ea3: "配额-上海",
  ea4: "配额-广州",
  ea5: "配额-湖北",
  ea6: "配额-福建",
  ea7: "配额-天津",
  ea8: "配额-深圳",
  ea9: "配额-重庆",
  ea10: "配额-四川",
  ea11: "配额-全国大宗",
  ccer1: "CCER-全国",
  ccer2: "CCER-北京",
  ccer3: "CCER-上海",
  ccer4: "CCER-广州",
  ccer5: "CCER-湖北",
  ccer6: "CCER-福建",
  ccer7: "CCER-天津",
  ccer8: "CCER-深圳",
  ccer9: "CCER-重庆",
  ccer10: "CCER-四川",
  lvzheng1: "lvzheng-全国",
  lvzheng2: "lvzheng-北京",
  lvzheng3: "lvzheng-上海",
  lvzheng4: "lvzheng-广州",
  lvzheng5: "lvzheng-湖北",
  lvzheng6: "lvzheng-福建",
  lvzheng7: "lvzheng-天津",
  lvzheng8: "lvzheng-深圳",
  lvzheng9: "lvzheng-重庆",
  lvzheng10: "lvzheng-四川",
  eay2: "配额(有偿竞价)-北京",
};

export const inputmodlname = {
  ea1: "全国-挂牌",
  ea2: "北京",
  ea3: "上海",
  ea4: "广州",
  ea5: "湖北",
  ea6: "福建",
  ea7: "天津",
  ea8: "深圳",
  ea9: "重庆",
  ea10: "四川",
  ea11: "全国-大宗",
  ccer1: "全国",
  ccer2: "北京",
  ccer3: "上海",
  ccer4: "广州",
  ccer5: "湖北",
  ccer6: "福建",
  ccer7: "天津",
  ccer8: "深圳",
  ccer9: "重庆",
  ccer10: "四川",
  lvzheng1: "lvzheng-全国",
  lvzheng2: "lvzheng-北京",
  lvzheng3: "lvzheng-上海",
  lvzheng4: "lvzheng-广州",
  lvzheng5: "lvzheng-湖北",
  lvzheng6: "lvzheng-福建",
  lvzheng7: "lvzheng-天津",
  lvzheng8: "lvzheng-深圳",
  lvzheng9: "lvzheng-重庆",
  lvzheng10: "lvzheng-四川",
  eay2: "配额(有偿竞价)-北京",
};
// 仅在tradetail.vue中使用
export const resetmoldtype = {
  ea: 1,
  ccer: 2,
  pcer: 3,
  fcer: 4,
  eay: 5,
  lvzheng: 6,
};
// 首页成交量使用映射关系trading.vue
export const dataTypeMap = {
  1: "配额",
  2: "CCER",
  3: "PCER",
  4: "FCER",
  5: "配额(有偿竞价)",
  6: "国内绿证",
  7: "绿电",
};
export const dataLocationMap = {
  1: "全国挂牌",
  2: "北京",
  3: "上海",
  4: "广州",
  5: "湖北",
  6: "福建",
  7: "天津",
  8: "深圳",
  9: "重庆",
  10: "四川",
  11: "全国大宗",
};

// 图片共享
export const modelImg = {
  1: require("../assets/cea1.png"),
  2: require("../assets/cea2.png"),
  3: require("../assets/cea3.png"),
  4: require("../assets/cea4.png"),
  5: require("../assets/cea5.png"),
  6: require("../assets/cea6.png"),
  7: require("../assets/cea7.png"),
  8: require("../assets/cea8.png"),
  9: require("../assets/cea9.png"),
  10: require("../assets/cea9.png"),
};

// 五大发电logo
export const logoImg = {
  1: require("../assets/gdtou.png"),
  2: require("../assets/guoneng.png"), // 国能
  3: require("../assets/huaneng.png"), // 华能
  4: require("../assets/huadian.png"), // 华电
  5: require("../assets/datang.png"), // 大唐
};
